// iOS reporta safe-area-inset-left/right SIMÉTRICOS em paisagem (o lado sem
// notch recebe o mesmo valor do lado com notch), então CSS puro não distingue
// qual lado recuar. Marcamos no <body> qual lado tem o notch/ilha e o CSS
// (index.css) recua só esse lado.
//
// GOTCHA (iOS Safari): o evento `screen.orientation "change"` NÃO dispara de
// forma confiável — a classe fica presa no valor do load e só um refresh
// corrige. Por isso reavaliamos em VÁRIAS fontes (matchMedia de orientação,
// resize, orientationchange legado) e re-aplicamos com um defer, porque
// `screen.orientation.angle` pode ainda não ter atualizado no instante do
// evento.
//
// Mapa calibrado empiricamente no iOS Simulator (screenshot rotacionado):
//   angle 90  → notch/ilha à ESQUERDA   (landscape-primary)
//   angle 270 (ou -90) → notch/ilha à DIREITA (landscape-secondary)
function notchSide() {
  const o = window.screen && window.screen.orientation;
  let angle =
    o && typeof o.angle === "number"
      ? o.angle
      : typeof window.orientation === "number"
        ? window.orientation
        : null;
  if (angle == null) {
    // fallback por type quando não há angle
    const type = o && o.type;
    if (type === "landscape-primary") return "left";
    if (type === "landscape-secondary") return "right";
    return null; // retrato / desconhecido → nenhum lado
  }
  angle = ((angle % 360) + 360) % 360; // normaliza -90 → 270
  if (angle === 90) return "left";
  if (angle === 270) return "right";
  return null; // 0 / 180 (retrato) → nenhum lado
}

function applyNotchSideClass() {
  if (!document.body) return;
  const side = notchSide();
  document.body.classList.toggle("notch-left", side === "left");
  document.body.classList.toggle("notch-right", side === "right");
}

// Reavalia agora e em cascata — no iOS o `screen.orientation.angle` só
// "assenta" no novo valor VÁRIOS frames depois do evento (pior na transição
// via upside-down, que é a mais longa). Os dois landscapes têm dimensões
// idênticas, então não dá pra confiar num único disparo de resize; re-checar
// ao longo de ~800ms cobre o settle tardio sem polling contínuo.
let pending = [];
function reevaluate() {
  pending.forEach(clearTimeout);
  pending = [];
  applyNotchSideClass();
  requestAnimationFrame(applyNotchSideClass);
  [100, 300, 600, 900].forEach((ms) => {
    pending.push(setTimeout(applyNotchSideClass, ms));
  });
}

export function installSafeAreaInsetTracking() {
  reevaluate();

  const o = window.screen && window.screen.orientation;
  // 1) screen.orientation (quando dispara — iOS é intermitente)
  if (o && o.addEventListener) o.addEventListener("change", reevaluate);
  // 2) matchMedia de orientação — o sinal mais confiável no iOS Safari
  if (window.matchMedia) {
    const mq = window.matchMedia("(orientation: landscape)");
    if (mq.addEventListener) mq.addEventListener("change", reevaluate);
    else if (mq.addListener) mq.addListener(reevaluate); // Safari legado
  }
  // 3) resize sempre dispara na rotação
  window.addEventListener("resize", reevaluate);
  // 4) orientationchange legado (deprecated, mas ainda funciona no iOS)
  window.addEventListener("orientationchange", reevaluate);
}
